import React, { useEffect, useState } from "react";
import { MdBusiness, MdCheck, MdClose } from "react-icons/md";
import { useHistory } from "react-router-dom";
import { useSelector } from "react-redux";

import ContainedButton from "components/layout/form/containedButton";
import OutlinedButton from "components/layout/form/outlinedButton";
import api from "services/api";

import {
  ContentButtons,
  ContentIcon,
  InfoCard,
  ModalBody,
  ModalContainer,
  ModalFooter,
  ModalHeader,
  ModalStyle,
} from "./styles";

const ModalBackToUnit = (): JSX.Element => {
  const [show, setShow] = useState(false);
  const [showReassing, setShowReassing] = useState(false);
  const [modalValues, setModalValues] = useState<any>({});
  const selectedUnit = useSelector(
    // @ts-ignore
    (state) => state.selectUnitReducer.selectedUnit
  );
  const history = useHistory();

  const { hasCurrentHouseholder, instanceId } = selectedUnit;

  useEffect(() => {
    if (!hasCurrentHouseholder) {
      setShow(true);
    }
  }, [hasCurrentHouseholder]);

  const openReassing = async (): Promise<void> => {
    const headers = {
      access_token: localStorage.getItem("@UltragazEmpresarial:accessToken"),
    };

    const { data } = await api.get(
      `industrial/customer/v1/units-status?instance-id=${instanceId}`,
      { headers }
    );

    const value = data[0];

    setModalValues({
      ...value,
      fullAddress: `${value?.address?.street}, ${value?.address?.number}, ${value?.address?.neighborhood}, ${value?.address?.city} - ${value?.address?.stateCode}`,
    });

    setShow(false);
    setShowReassing(true);
  };

  const advancedReassing = (): void => {
    history?.push("/retornar-unidade");
  };

  const handleOwnerName = (fullName): string => {
    let nameList = fullName?.split(" ");
    if (nameList) {
      nameList = nameList.map((name) => {
        let dots = "";
        const sliceName = name.slice(2, name.length - 1);
        for (let i = 0; i < sliceName.length - 1; i += 1) {
          dots += "*";
        }
        return name.replace(sliceName, dots);
      });
      return nameList.join(" ");
    }

    return "";
  };

  return (
    <>
      <ModalStyle
        show={show}
        onHide={() => setShow(false)}
        centered
        backdrop="static"
        keyboard={false}
      >
        <ModalContainer>
          <ModalHeader>
            <div>
              <h2>Apartamento/Loja não está em seu nome</h2>
              <MdClose size={24} onClick={() => setShow(false)} />
            </div>
          </ModalHeader>

          <p>
            Essa unidade não está na sua titularidade, por isso apresentaremos
            apenas o <strong>histórico do período em que esteve.</strong>
          </p>

          <ContentButtons>
            <OutlinedButton onClick={openReassing}>
              Retomar a titularidade da unidade
            </OutlinedButton>
            <ContainedButton onClick={() => setShow(false)}>
              Visualizar histórico
            </ContainedButton>
          </ContentButtons>
        </ModalContainer>
      </ModalStyle>
      <ModalStyle
        show={showReassing}
        onHide={() => setShowReassing(false)}
        centered
      >
        <ModalContainer>
          <ModalHeader>
            <div>
              <h2>Troca de titularidade</h2>
              <MdClose size={24} onClick={() => setShowReassing(false)} />
            </div>
          </ModalHeader>
          <p>Deseja prosseguir com a troca de titularidade para a unidade?</p>
          <ModalBody>
            <ContentIcon>
              <MdBusiness size={30} />
            </ContentIcon>
            <div>
              <p>
                <strong>{modalValues?.condominiumName}</strong>
                <br />
                {modalValues?.fullAddress}
              </p>
              <InfoCard>
                <p>
                  <strong>DADOS DO RESPONSÁVEL ATUAL DA UNIDADE</strong>
                </p>
                <br />
                <p>
                  <strong>Nome: </strong>
                  {handleOwnerName(modalValues?.customerName)}
                </p>
                <p />
                <p>
                  <strong>Bloco: </strong>
                  {modalValues?.unitComplement}
                </p>
                <p>
                  <strong>Apartamento / Loja: </strong>
                  {modalValues?.unitNumber}
                </p>
              </InfoCard>
            </div>
          </ModalBody>
          <ModalFooter>
            <ContainedButton
              color="#E34E2A"
              LeadingIcon={MdClose}
              propsLeadingIcon={{
                size: 24,
              }}
              onClick={() => setShowReassing(false)}
            >
              Não
            </ContainedButton>
            <ContainedButton
              color="#75B943"
              LeadingIcon={MdCheck}
              propsLeadingIcon={{
                size: 24,
              }}
              onClick={() => advancedReassing()}
            >
              Confirmar
            </ContainedButton>
          </ModalFooter>
        </ModalContainer>
      </ModalStyle>
    </>
  );
};

export default ModalBackToUnit;
